import React, { Fragment } from 'react';
import { get } from 'lodash';

import { getInputClasses, getValidationStatus } from 'Components/frameworks/formik/inputsUtils';

import { DataListInput } from './DatalistInput';
import { Label } from './Label';

export const Datalist = ({
  className,
  dataTestId,
  field,
  form,
  isDisabled = false,
  isRequired = false,
  label,
  setOrDefault,
  options,
}) => {
  const selectedValue = get(form.values, field.name, '');
  const { isDefaultState, isErrored, isValidated } = getValidationStatus(
    { ...field, value: selectedValue },
    form,
    isDisabled,
  );

  const classes = getInputClasses({
    hasHeight: true,
    isDefaultState,
    isDisabled,
    isErrored,
    isValidated,
  });

  const handleOnSelectOrBlure = (value) => {
    value && form.setFieldValue(field.name, setOrDefault(value));
  };

  return (
    <Fragment>
      {!!label && (
        <Label
          className="mx-15 mb-5"
          htmlFor={field.name}
          isErrored={isErrored}
          isRequired={isRequired}
          label={label}
        />
      )}
      <DataListInput
        activeItemClassName=""
        className={className}
        dataTestId={dataTestId}
        dropdownClassName=""
        dropDownLength={0}
        field={field}
        inputClassName={classes}
        itemClassName=""
        items={options.map(({ label: itemLabel, value }) => ({ label: itemLabel, key: value }))}
        onSelect={handleOnSelectOrBlure}
        onBlur={handleOnSelectOrBlure}
        placeholder=""
        value={selectedValue}
      />
    </Fragment>
  );
};
